import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';

import { SvgIconModule } from '../../components';
import { AugmentedPlayerModule } from "../../components/augmented-player/augmented-player.module";
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { OfflineModule } from '../../offline';

import { AudioPlayer } from './audio-player.component';


@NgModule({
    declarations: [
        AudioPlayer,
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        MotePipesModule,
        OfflineModule,
        AugmentedPlayerModule
    ],
    exports: [
        AudioPlayer
    ]
})
export class AudioPlayerModule { }
